import { connect } from "react-redux";
import Login from "../../components/login/Login";
import { signIn } from "../../actions/user.actions";

const mapDispatchToProps = dispatch => ({
    signIn: (username, password) => dispatch(signIn({username, password})),
});

export default connect(null, mapDispatchToProps)(Login);
